export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '北京市朝阳区豆各庄黄厂西路1号C5栋三层',
  uc_host: 'http://user.7office.net',
  site_host: 'http://www.7office.net',
  special_url: '/',
  site_title: '七天软文-软文精准营销平台',
  welcome_title: '七天软文 — 软文精准营销平台！',
  site_short_title: '七天软文',
  site_subtitle: '软文精准营销平台',
  company_name: '北京新谊科技有限公司',
  copyright: '© 2025 北京新谊科技有限公司',
  logo: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/251107/ebb4f4ef3c992df7f1e6383a7cfbf7cf.png',
  favicon: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/250925/5eb146da6abf9d8e34ff95062bba30f4.png',
  payment: '',
  qq: '',
  tel: '18500774433',
  company_account_id: '349369078401',
  company_bank: '中国银行股份有限公司北京奥运村支行',
  company_bank_name: '北京新谊科技有限公司',
  alipay_account_id: '122310592@qq.com',
  alipay_name: '王鹏',
  alipay_pic: '',
  wechat_pic: 'https://fagao.oss-cn-shanghai.aliyuncs.com/uploads/190/260114/58984ce7bdb146fe850bcd870c574929.jpg',
  section_id: 5346960,
  belonger_id: 5346960,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 